import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectParamsSetting } from './store/slice'
import { selectIsAllCheck } from './store/slicePortfolio'

export const useSettingParams = () => {
  const isAll = useSelector(selectIsAllCheck)
  const settingParams = useSelector(selectParamsSetting)

  const params = useMemo(() => {
    if (!settingParams || !Object.keys(settingParams).length || isAll === null)
      return null

    return {
      ...settingParams,
      portfolioIds: isAll ? [] : settingParams.portfolioIds,
    }
  }, [settingParams, isAll])

  return params
}
